var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 1C6.14874 1 5.82323 1.1843 5.64251 1.4855L4.43381 3.5H1C0.447716 3.5 0 3.94772 0 4.5V18C0 18.5523 0.447716 19 1 19H19C19.5523 19 20 18.5523 20 18V4.5C20 3.94772 19.5523 3.5 19 3.5H15.5662L14.3575 1.4855C14.1768 1.1843 13.8513 1 13.5 1H6.5ZM5.85749 5.0145L7.06619 3H12.9338L14.1425 5.0145C14.3232 5.3157 14.6487 5.5 15 5.5H18V17H2V5.5H5C5.35126 5.5 5.67677 5.3157 5.85749 5.0145ZM10 6.5C7.51472 6.5 5.5 8.51472 5.5 11C5.5 13.4853 7.51472 15.5 10 15.5C12.4853 15.5 14.5 13.4853 14.5 11C14.5 8.51472 12.4853 6.5 10 6.5ZM12.5 11C12.5 12.3807 11.3807 13.5 10 13.5C8.61929 13.5 7.5 12.3807 7.5 11C7.5 9.61929 8.61929 8.5 10 8.5C11.3807 8.5 12.5 9.61929 12.5 11ZM16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.dc9d8fabe1999023d587da5ad6fbd21d.svg";
export { ForwardRef as ReactComponent };